import { X, Check } from "lucide-react";

const traditional = ["Buy a second server", "Ship & install hardware", "Configure firewall & VPN", "Purchase disks", "Monitor & replace failed disks", "Patch the server yourself", "Manage an offsite facility"];
const zettakeep = ["Choose your storage", "Choose your region", "Click Deploy", "Connect Proxmox", "Backups begin — done"];

export default function ComparisonTable() {
  return (
    <div className="grid gap-5 md:grid-cols-2">
      <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
        <div className="mb-4 text-sm font-semibold uppercase tracking-widest text-slate-500">Traditional Offsite PBS</div>
        <ul className="space-y-3">
          {traditional.map((t) => (
            <li key={t} className="flex items-start gap-3 text-sm text-slate-400">
              <X className="mt-0.5 h-4 w-4 shrink-0 text-rose-400/80" /> {t}
            </li>
          ))}
        </ul>
      </div>
      <div className="rounded-2xl border border-cyan-500/30 bg-gradient-to-b from-cyan-500/5 to-transparent p-6 zk-glow">
        <div className="mb-4 text-sm font-semibold uppercase tracking-widest text-cyan-300">ZettaKeep</div>
        <ul className="space-y-3">
          {zettakeep.map((t) => (
            <li key={t} className="flex items-start gap-3 text-sm text-slate-200">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" /> {t}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
